import { createAction } from '@reduxjs/toolkit';

import { errorPayloadCreator, getPayloadCreator } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { UserInfoProps } from './userInfoTypes';

export const getUserInfo = createAction('GET_USER_INFO', getPayloadCreator());
export const getUserInfoSuccess = createAction(
  'GET_USER_INFO_SUCCESS',
  getPayloadCreator<QcsSyncResourcesPayload<UserInfoProps>>(),
);
export const getUserInfoFailure = createAction('GET_USER_INFO_FAILURE', errorPayloadCreator);

export const userRegisterMeForBeta = createAction(
  'USER_REGISTER_ME_FOR_BETA',
  getPayloadCreator<{ clientId: string }>(),
);
export const userRegisterMeForBetaSuccess = createAction('USER_REGISTER_ME_FOR_BETA_SUCCESS');
export const userRegisterMeForBetaFailure = createAction('USER_REGISTER_ME_FOR_BETA_FAILURE', errorPayloadCreator);

export const userUnregisterMeForBeta = createAction(
  'USER_UNREGISTER_ME_FOR_BETA',
  getPayloadCreator<{ clientId: string }>(),
);
export const userUnregisterMeForBetaSuccess = createAction('USER_UNREGISTER_ME_FOR_BETA_SUCCESS');
export const userUnregisterMeForBetaFailure = createAction('USER_UNREGISTER_ME_FOR_BETA_FAILURE', errorPayloadCreator);
